export const API_URL =
  typeof window !== 'undefined' ? `${window.location.origin}/api` : '/api';
